<button
	mat-button
	class="sidebar-menu-trigger"
	[matMenuTriggerFor]="helpMenu"
	[attr.aria.label]="'sidebar.help' | transloco"
	[attr.aira-haspopup]="'menu'"
	[attr.aria-expanded]="helpMenuTrigger.menuOpen"
	[attr.aria-controls]="helpMenu.panelId"
	#helpMenuTrigger="matMenuTrigger"
>
	<mat-icon font-icon="manage_accounts" aria-hidden="true">help_outline</mat-icon>
	{{ 'sidebar.help' | transloco }}
</button>

<mat-menu #helpMenu="matMenu" yPosition="above">
	<div class="menu-content">
		<button mat-menu-item [attr.aria-label]="'sidebar.bugReport' | transloco" (click)="requestBugReport()">
			<mat-icon fontIcon="bug_report" aria-hidden="true"></mat-icon>
			{{ 'sidebar.bugReport' | transloco }}
		</button>
		<button mat-menu-item [attr.aria-label]="'sidebar.manual'" disabled>
			<mat-icon fontIcon="menu_book" aria-hidden="true"></mat-icon>
			<!--TODO: Implement functionality for the manual-->
			{{ 'sidebar.manual' | transloco }}
		</button>
	</div>
</mat-menu>
